import { useEffect, useState } from "react";
import { getLegalMeta } from "../../Services/AuthService";
import Footer from "../../Components/Footer";
import "../../Styles/Legal.css";

/**
 * Kontaktsidan.
 *
 * Ingen kontaktformulär-endpoint finns, och den ska inte fejkas: ett
 * formulär som inte skickar något är värre än en adress som fungerar.
 * Adressen kommer från API:et (CONTACT_EMAIL) med en rimlig fallback, så
 * den kan bytas utan en ny deploy av klienten.
 */
export default function Contact() {
  const [email, setEmail] = useState("hello@beatspot.app");

  useEffect(() => {
    let cancelled = false;

    getLegalMeta()
      .then((meta) => {
        if (!cancelled && meta.contactEmail) setEmail(meta.contactEmail);
      })
      .catch(() => {
        // Fallback-adressen står kvar.
      });

    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <>
      <main className="legal-page">
        <header className="legal-header">
          <h1>Contact</h1>
          <p>We are a small team in Gothenburg. Email is the fastest way to reach us.</p>
        </header>

        <section className="legal-section" id="general">
          <h2>General questions</h2>
          <p>
            <a href={`mailto:${email}`}>{email}</a>
          </p>
        </section>

        <section className="legal-section" id="venues">
          <h2>Venues</h2>
          <p>
            Interested in a live profile or a pilot sensor? Write to{" "}
            <a href={`mailto:${email}?subject=Venue`}>{email}</a> with the name of
            the place and we will get back to you.
          </p>
        </section>

        <section className="legal-section" id="privacy">
          <h2>Privacy and your data</h2>
          <p>
            You can download or delete your data yourself under Settings. For
            anything else, email{" "}
            <a href={`mailto:${email}?subject=Privacy`}>{email}</a> and we will
            answer within 30 days.
          </p>
        </section>

        <section className="legal-section" id="safety">
          <h2>Reporting someone</h2>
          <p>
            Use the report option on the person's profile — it reaches us faster
            than email and gives us the context we need. For urgent safety
            matters, contact the police.
          </p>
        </section>
      </main>

      <Footer />
    </>
  );
}
